import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthService } from './authentication/auth.service';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AuthGuard } from './authentication/auth.guard';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AngularFireAuthModule,
    AngularFirestoreModule
  ],
  providers: [
    AuthService,
    AuthGuard
  ]
})
export class CoreModule { }
